import { CarrotCardCantBeUsedStep } from "#/components/carrot-card-cost-share/steps/views/CarrotCardCantBeUsedStep"
import { PregnantPostpartumSteps } from "#/components/carrot-card-cost-share/workflows/step-library"

export enum Workflows {
  PREGNANT_AND_POSTPARTUM = "Pregnant And Postpartum Workflow"
}

export const pregnantPostpartumSteps = [
  { name: PregnantPostpartumSteps.CARROT_CARD_CANT_BE_USED, component: CarrotCardCantBeUsedStep }
]

//prettier-ignore
const pregnantPostpartumFlow: PregnantPostpartumFlowTransition[] = [
  { at: PregnantPostpartumSteps.CARROT_CARD_CANT_BE_USED,  given: "",  end: true }
]

type PregnantPostpartumFlowTransition = { at: PregnantPostpartumSteps; given: string; end: true }

export const pregnantPostpartumWorkflows = [
  { name: Workflows.PREGNANT_AND_POSTPARTUM, workflow: pregnantPostpartumFlow }
]
